import { NotificationModal } from 'views/components';
import { configurationActions } from 'core/Configuration';
import { dateToObject } from 'shared/utils';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Card,
    Container,
    DateSelect,
    ExpandButton,
    FormGroup,
    IconButton,
    Input,
    Loader,
    Text
} from 'mol-ui';
import { Col, Row } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import {
    useArray,
    useDispatch,
    useInput,
    useSelector,
    useWindowSize
} from 'hooks';

const MethodByDay = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { xs } = useWindowSize();
    const {
        absenceRate,
        absenceRateLoading,
        absenceRateProcessing: processing,
        absenceRateUpserted
    } = useSelector('configuration');
    const [date, setDate] = useState(dateToObject(moment()));
    const [employeesPerWorkPlace, setEmployeesPerWorkplace, {
        replaceValues: replaceEmployees
    }] = useArray([], { type: 'object' });
    const [workdays, setWorkdays] = useState();
    const [workplaceInput, workplaceFilter] = useInput('');

    const handleCopyWorkplaceEmployees = () => {
        setEmployeesPerWorkplace(currentWorkplaces => currentWorkplaces.map(workplace => ({
            ...workplace,
            employees: workplace?.workplace_employees ?? workplace?.employees
        })));
    };

    useEffect(() => {
        const data = {
            month: Number(date?.month),
            year: Number(date?.year)
        };
        dispatch(configurationActions.getAbsenceRateConfiguration(data));
    }, [date]);

    useEffect(() => {
        if (isEmpty(absenceRate)) return;
        const { workdays, workplaces } = absenceRate ?? {};
        setWorkdays(workdays);
        setEmployeesPerWorkplace(workplaces);
    }, [absenceRate]);

    const onSubmit = () => {
        const payload = {
            month: Number(date?.month),
            workdays,
            workplaces: employeesPerWorkPlace,
            year: Number(date?.year)
        };
        dispatch(configurationActions.upsertAbsenceRateConfiguration(payload));
    };

    const filteredEmployeesPerWorkPlace = employeesPerWorkPlace.filter(({ name }) => !workplaceFilter || name.toLowerCase().indexOf(workplaceFilter.toLowerCase()) >= 0);

    return (
        <Container>
            <NotificationModal
                singleButton
                active={ absenceRateUpserted }
                height="auto"
                title={ t('Configuración actualizada correctamente') }
                onBack={ () => dispatch(configurationActions.setConfigurationAbsenceRateUpserted(false)) }
            />
            <Row>
                <FormGroup label={ t('Mes y año') }>
                    <Col sm={ 6 } xs={ 12 }>
                        <DateSelect
                            hideDays={ true }
                            margin="0px 0px 20px 0px"
                            nextYears={ 1 }
                            value={ date }
                            onChange={ value => setDate(value) }
                        />
                    </Col>
                </FormGroup>
                {
                    absenceRateLoading
                        ? <Loader active />
                        : <>
                            <FormGroup label={ t('Cantidad de jornadas laborales') }>
                                <Col sm={ 3 } xs={ 12 }>
                                    <Input
                                        type="number"
                                        value={ (workdays !== null || workdays !== undefined) ? (workdays ?? 0).toString() : '' }
                                        onChange={ value => setWorkdays(value) }
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup label={ `${ t('Buscar lugar de trabajo') }...` } margin="20px 0px 0px 0px">
                                <Input { ...workplaceInput } />
                            </FormGroup>
                            <IconButton
                                icon="copy_all"
                                label={ t('Utilizar valores actuales') }
                                margin="0px 0px 10px 0px"
                                size={ 16 }
                                onClick={ handleCopyWorkplaceEmployees }
                            />
                            <Card margin="0px 0px 20px 0px" maxHeight="400px" overflowY="auto" title={ t('Lugares de trabajo y cantidad de empleados') } width="100%">
                                {
                                    filteredEmployeesPerWorkPlace.map(places => {
                                        const { employees, name, workplace_employees, workplace_id } = places;
                                        return <Container alignItems="center" flexDirection="row" key={ workplace_id } margin="5px 0px 0px 0px">
                                            <Text margin="0px 5px 0px 0px">
                                                { name }
                                            </Text>
                                            {
                                                !!workplace_employees &&
                                                <Text fontSize="10px" margin="0px 5px 0px 0px">
                                                    ({ t('Actuales') }: { workplace_employees })
                                                </Text>
                                            }
                                            <Input
                                                flex="1"
                                                height="20px"
                                                margin="0px"
                                                type="number"
                                                value={ employees }
                                                width={ xs ? '100%' : '100px' }
                                                onChange={ value => replaceEmployees({ employees: value }, 'workplace_id', workplace_id) }
                                            />
                                        </Container>;
                                    })
                                }
                            </Card>
                            <ButtonFooter margin="20px 0px 0px 0px">
                                <ExpandButton
                                    caption={ t('Confirmar') }
                                    loading={ processing }
                                    size={ 100 }
                                    onClick={ onSubmit }
                                />
                            </ButtonFooter>
                        </>
                }
            </Row>
        </Container>
    );
};

MethodByDay.propTypes = {
    
};

export { MethodByDay };
